// extracted by mini-css-extract-plugin
export default {"search_container":"styles_search_container__xJTY2","search_input":"styles_search_input__2C-QN"};